import styled from 'foundations-theming-specialty/utils';
import { Breadcrumbs } from 'foundations-components/transitional/components/Breadcrumbs';
import { Flex } from 'foundations-components/components/Flex';
import { useIsUngated } from 'portals-platform-lib';
import { GATES } from '../constants/gates';
import { PAGE_CONTENT_SPACING } from '../constants/layout';
import { ROUTES } from '../constants/routes';
import { Link as RouterLink, useParams } from 'quartz-routing/react-router';
import { useTicketListingsHeading } from '../hooks/useTicketListingsHeading';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BreadcrumbResetWrapper = styled.div.withConfig({
  displayName: "BreadcrumbContainer__BreadcrumbResetWrapper"
})(["> nav{margin:0;font-size:", ";}"], ({
  theme
}) => theme.typography['body-100'].fontSize);
export function BreadcrumbContainer() {
  const isUnifiedShell = useIsUngated(GATES.UNIFIED_SHELL);
  const ticketListingsHeading = useTicketListingsHeading();
  const {
    ticketId
  } = useParams();
  if (!isUnifiedShell) {
    return null;
  }
  return /*#__PURE__*/_jsx(Flex, {
    alignItems: "center",
    paddingBlock: "500",
    paddingInline: PAGE_CONTENT_SPACING,
    children: /*#__PURE__*/_jsx(BreadcrumbResetWrapper, {
      children: /*#__PURE__*/_jsxs(Breadcrumbs, {
        flush: true,
        children: [/*#__PURE__*/_jsx(RouterLink, {
          to: ROUTES.root,
          children: ticketListingsHeading
        }), /*#__PURE__*/_jsx("span", {
          children: `#${ticketId}`
        })]
      })
    })
  });
}